export type GiftThisArticleProps = {
  giftLeft: number;
};

export default function GiftThisArticle({
  giftLeft,
}: GiftThisArticleProps): React.ReactElement {
  const articleText = giftLeft > 1 ? "articles" : "article";

  return (
    <>
      <p className="font-poppins text-base">
        {
          "Share this link and remind your recipient to redeem the gifted story within 14 days."
        }
      </p>

      <p className="font-poppins text-base">
        {`You currently have ${giftLeft} ${articleText} left to gift for this month`}
        .
      </p>
    </>
  );
}
